import type { FsnbWorkCardLine, FsnbWorkCoefficient } from '@shared/api';
import { fmtNum } from '@shared/lib/smetaLabels';
import type { CompareLine } from './types';

export function copy(text: string): void {
  void navigator.clipboard?.writeText(text);
}

export function lineName(l: FsnbWorkCardLine): string {
  if (l.role === 'machinist_labor') return l.end_name || 'Затраты труда машинистов';
  return l.catalog_name || l.end_name || '—';
}

export function lineUnit(l: FsnbWorkCardLine): string {
  if (l.role === 'labor' || l.role === 'machinist_labor') return l.unit || 'чел.-ч';
  return l.catalog_unit || l.unit || '—';
}

/** Группа сборника длиннее этого — свёрнута: такие коэффициенты (подземные
 *  условия, движение поездов…) относятся ко всем нормам сборника и заслоняют
 *  коэффициенты самой нормы и её таблицы. */
export const COLLAPSE_COLLECTION_OVER = 5;

/** Коэффициенты нормы, сгруппированные по привязке: к норме, таблице,
 *  разделу, сборнику (порядок задаёт сервер). */
export function groupCoefficients(items: FsnbWorkCoefficient[]) {
  const groups: Array<{
    key: string;
    scope: FsnbWorkCoefficient['scope'];
    code: string;
    items: FsnbWorkCoefficient[];
  }> = [];
  for (const c of items) {
    const key = `${c.scope}:${c.scope_code}`;
    const g = groups.find((x) => x.key === key);
    if (g) g.items.push(c);
    else groups.push({ key, scope: c.scope, code: c.scope_code, items: [c] });
  }
  return groups;
}

export function compareLines(before: FsnbWorkCardLine[], after: FsnbWorkCardLine[]): CompareLine[] {
  const byCode = new Map<string, FsnbWorkCardLine>();
  for (const l of before) byCode.set(l.resource_code, l);
  const out: CompareLine[] = [];
  const seen = new Set<string>();
  for (const l of after) {
    const prev = byCode.get(l.resource_code);
    seen.add(l.resource_code);
    out.push({
      code: l.resource_code,
      name: lineName(l),
      unit: lineUnit(l),
      before: prev?.quantity,
      after: l.quantity,
      state: !prev ? 'added' : prev.quantity !== l.quantity ? 'changed' : 'same',
    });
  }
  for (const l of before) {
    if (seen.has(l.resource_code)) continue;
    out.push({
      code: l.resource_code,
      name: lineName(l),
      unit: lineUnit(l),
      before: l.quantity,
      after: undefined,
      state: 'removed',
    });
  }
  return out;
}

export function qty(v: number | null | undefined): string {
  if (v === undefined) return '';
  return v === null ? 'по проекту' : fmtNum(v);
}
